export function formatHealthRelativeTime(value, t) {
	if (!value) return t('notification_health_time_unknown');

	const date = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(date.getTime())) return t('notification_health_time_unknown');

	const diffMinutes = Math.floor((Date.now() - date.getTime()) / 60000);
	if (diffMinutes < 1) return t('notification_health_time_just_now');
	if (diffMinutes < 60) return t('notification_health_time_minutes', { count: diffMinutes });

	const diffHours = Math.floor(diffMinutes / 60);
	if (diffHours < 48) return t('notification_health_time_hours', { count: diffHours });

	return t('notification_health_time_days', { count: Math.floor(diffHours / 24) });
}

export function resolveHealthDetailParams(detailParams, t) {
	const params = { ...(detailParams || {}) };

	if (params.at) {
		params.time = formatHealthRelativeTime(params.at, t);
		delete params.at;
	}

	if (params.lastSyncAt) {
		params.lastSync = formatHealthRelativeTime(params.lastSyncAt, t);
		delete params.lastSyncAt;
	}

	if (params.mode) {
		const modeKey = `notification_health_mode_${params.mode}`;
		params.mode = t(modeKey) !== modeKey ? t(modeKey) : params.mode;
	}

	if (params.filter) {
		const filterKey = `notification_health_filter_${params.filter}`;
		params.filter = t(filterKey) !== filterKey ? t(filterKey) : params.filter;
	}

	return params;
}

export function healthCheckLabelKey(checkId) {
	return `notification_health_check_${checkId}_label`;
}
